import React, { useEffect } from "react";
import "./certs.css";
import { trackPortfolioVisit, trackCertificationView } from "../../utils/analytics";

function Certs() {
  const Microsoft =
    "https://learn.microsoft.com/en-us/users/lusadumamata-2985/credentials/25d146e506d2ef82?ref=https%3A%2F%2Fwww.linkedin.com%2F";
  const AWS =
    "https://www.credly.com/badges/20270a4a-a755-4702-b935-7447edabb8f6";
  const FortinetAssociate =
    "https://www.credly.com/badges/94d506bc-101c-4e30-850c-cafddd06f36d";
  const FortinetFundamentals =
    "https://www.credly.com/badges/2bcc1201-857e-4980-b693-60ef20c7e63f";

  useEffect(() => {
    // Track when Certifications section is loaded
    trackPortfolioVisit('certifications');

    const cards = document.querySelectorAll(".card");

    if (window.innerWidth <= 1024) {
      // Apply on mobile and tablet devices
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Unflip all other cards before flipping this one
              cards.forEach((card) => card.classList.remove("visible"));
              entry.target.classList.add("visible");
            }
          });
        },
        { threshold: 0.95 }
      );

      cards.forEach((card) => observer.observe(card));

      return () => observer.disconnect(); // Cleanup observer on unmount
    }
  }, []);

  return (
    <div className="certs-container">
      <div className="center">
        <section id="certificates">
          <h1 className="heading">
            <span className="text autoplay">CERTIFICATIONS</span>
          </h1>
        </section>
      </div>

      {/* makes sure that all the cards are in a row when displayed in desktop view */}
      <div className="card-containerr">
        {/* Microsoft Azure AI */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="card">
            <img src="/images/AI.png" alt="Fortinet fundamental" />
            <div className="card__content">
              <p className="card__title">
                Microsoft Certified - Azure AI Fundamentals
              </p>
              <p className="card__description">
                This certification demonstrates the knowledge of machine
                learning and AI concepts and related Microsoft Azure services
                <br></br>
                <br></br>
                <b>Skills:</b>
                <br></br>
                Artificial Intelligence (AI), Cloud Computing, Microsoft Azure,
                Microsoft Azure Cloud Services
              </p>
              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <a
                href={Microsoft}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", justifyContent: "center" }}
                onClick={() => trackCertificationView('microsoft_azure')}
              >
                <button className="button"> View certificate online </button>
              </a>
            </div>
          </div>
        </div>

        {/* Fortinet associate */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="card">
            <img
              src="/images/Fortinet associate.png"
              alt="Fortinet associate"
            />
            <div className="card__content">
              <p className="card__title">
                Fortinet Certified Associate - Cybersecurity
              </p>
              <p className="card__description">
                This certification covered the fundamentals of operating the
                most common FortiGate features.<br></br>
                <br></br>
                <b>Skills:</b>
                <br></br>
                Anti-virus, Authentication, Cybersecurity,
                Firewall, FortiGate, Intrusion Detection Systems, SSL
                Inspection, Virtual Private Networks (VPN), Web Filtering
              </p>
              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <a
                href={FortinetAssociate}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", justifyContent: "center" }}
                onClick={() => trackCertificationView('fortinet_associate')}
              >
                <button className="button"> View certificate online </button>
              </a>
            </div>
          </div>
        </div>

        {/* AWS */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="card">
            <img
              src="/images/AWS pic.png"
              alt="AWS Certified Cloud Practitioner"
            />
            <div className="card__content">
              <p className="card__title">
                AWS Certified Cloud Practitioner - Foundational
              </p>
              <p className="card__description">
                This certification covered IT services and their uses in the AWS
                Cloud. I have demonstrated cloud fluency and foundational AWS
                knowledge.
                <br></br>
                <br></br>
                <b>Skills:</b>
                <br></br>
                Amazon Web Services, AWS Cloud, Cloud Computing, Cloud Platform,
                Cloud Services
              </p>

              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <a
                href={AWS}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", justifyContent: "center" }}
                onClick={() => trackCertificationView('aws_cloud_practitioner')}
              >
                <button className="button"> View certificate online </button>
              </a>
            </div>
          </div>
        </div>

        {/* Fortinet fundamentals */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="card">
            <img
              src="/images/Fortinet fundamental.png"
              alt="Fortinet fundamental"
            />
            <div className="card__content">
              <p className="card__title">
                Fortinet Certified Fundamentals - Cybersecurity
              </p>
              <p className="card__description">
                This certification validates the technical skills and knowledge
                that is required for any entry-level job role in cybersecurity.
                <br></br>
                <br></br>
                <b>Skills:</b>
                <br></br>
                Cloud Services, Cryptography, Cybersecurity Threats, Endpoint
                Security, Malware Attacks, Network Security, Social Engineering
              </p>
              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <a
                href={FortinetFundamentals}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", justifyContent: "center" }}
                onClick={() => trackCertificationView('fortinet_fundamentals')}
              >
                <button className="button"> View certificate online </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Certs;
